var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58325 7.16663V18",
    stroke: "#2A3D4A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5834V18",
    stroke: "#2A3D4A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.41667V3",
    stroke: "#2A3D4A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 3V13.8333",
    stroke: "#2A3D4A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 7.16667C5.73392 7.16667 6.66667 6.23392 6.66667 5.08333C6.66667 3.93274 5.73392 3 4.58333 3C3.43274 3 2.5 3.93274 2.5 5.08333C2.5 6.23392 3.43274 7.16667 4.58333 7.16667Z",
    stroke: "#2A3D4A",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 12.5833C11.1507 12.5833 12.0834 11.6505 12.0834 10.5C12.0834 9.34938 11.1507 8.41663 10.0001 8.41663C8.8495 8.41663 7.91675 9.34938 7.91675 10.5C7.91675 11.6505 8.8495 12.5833 10.0001 12.5833Z",
    stroke: "#2A3D4A",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 18C16.5672 18 17.4999 17.0673 17.4999 15.9167C17.4999 14.7661 16.5672 13.8334 15.4166 13.8334C14.266 13.8334 13.3333 14.7661 13.3333 15.9167C13.3333 17.0673 14.266 18 15.4166 18Z",
    stroke: "#2A3D4A",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.9a98106e7a8c29c378c20aba8988d83e.svg";
export { ForwardRef as ReactComponent };